<template>
  <CContainer fluid>
    <CRow class="justify-content-center" style="margin-top:100px">
        <CCol sm="5" lg="7">
          <CCol>
     <div class="card">
      <div class="card-body">
        <b><h3> QR CODE GENERATOR </h3></b>
        <h5 style="color:grey;"> Generate your QR Code to see your order detail</h5>
    <CRow class="mt-3">
      <CCol sm="9" >
     
      <!-- <b-input ref="text" v-model="result" id="feedback-user" class="mb-1" @keyup.enter.native="scan" @input="changeHandler"> </b-input> -->
      <b-input  placeholder="Your QR Code will be generated automatically" ref="text" v-model="result" id="feedback-user" class="mb-1" @input="changeHandler"> </b-input>
      </CCol>
      <CCol sm="3">
      <CButton block color="info" @click="scan">Scan</CButton>
      <alertmodal></alertmodal>
      </CCol>
    </CRow>
    <strong id="error"></strong>
   </div>
     </div>
      </CCol>
        </CCol>
      </CRow>
      <CRow class="justify-content-center" >
        <CCol sm="5" lg="7">
          <CCol>
     <div class="card"  v-if="result_hide === false" >
      <div class="card-body">
    <CRow>
      <CCol  sm="6">
            <row class="mt-3">
              <h4 class="ml-5 "> Orders Detail </h4> 
            </row>
            <br>
            <row >
              <p class="ml-5"> Booking ID: <b> {{ data.booking_id }}</b> </p>
              <p class="ml-5"> Name: <b> {{ data.name }} </b></p>
              <p class="ml-5"> Address:<b> {{ data.address }} </b> </p>
              <p class="ml-5"> Email: <b>{{ data.email }} </b> </p>
              <p class="ml-5"> Mobile Phone: <b> {{ data.mobile_phone }} </b> </p>
              <p class="ml-5"> Payment Status: <b>{{ data.payment_status }} </b></p>
            </row>
            <br>
            <row >
            </row>
      </CCol>
      <CCol  sm="4">
                <h4 > Ticket Detail </h4> 
         <br>
            <row class=" mt-3">
              
              <table>
                  <thead>
                  <tr>
                      <th>Name</th>
                      <th>Quantity</th>
                      <th>Attend</th>
                  </tr>
                  </thead>
                  <tr v-for="(arr, index) in form.att" :key="index">
                      <td>
                        {{ arr.type.name }}
                      </td>
                      <td>
                          {{ arr.qty }} Ticket
                      </td>
                      <td>
                          <CInput
                            type="number"
                            label=""
                            v-model="arr.attend"
                            min="0"    
                            :invalid-feedback="messageInvalidFeedback(arr.qty)"  
                            :is-valid="validatorTicket(arr.attend,arr.qty)"              
                          />
                      </td>
                  </tr>
                  
              </table>
            </row>
              <div  class="d-flex justify-content-end">
              <CRow v-if="!loading_submit" class="mt-3" >
              <CCol >
              <CButton  block color="success"  v-on:click.prevent="submit()" type="submit">Submit</CButton>
              </CCol>
            </CRow>
            <CRow v-else >
              <b-spinner variant="primary" label="Spinning"><br></b-spinner>
            </CRow>
              </div>
            
      </CCol>
      
    </CRow>
      
      </div>
      
     </div>
     
          </CCol>
          
        </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'

import event from '@/services/event'
import EventBus from '@/eventBus';
import alertmodal from '@/views/alert/modal.vue';

export default {

  components: { QrcodeStream, alertmodal },

  data () {
    return {
      data:[],
      id: '',
      form:{
        att:[],
      },
      result: '',
      error: '',
      camera_hide: false,
      result_hide: true,
      message: '',
      message_hide: true,
      loading_submit: false,
    }
  },

  mounted(){
    this.$refs.text.$el.focus();

      EventBus.$on('PAGE_RELOAD', (data) => {
      if(data){
         this.$refs.text.$el.focus();
         this.result = '';
      }
      });   

    var self = this;
    window.addEventListener('keyup', function(event) {
      if (event.keyCode === 13) { 
        //alert('press enter')
        self.check123();
      }
    });


  },


  methods: {
    // onDecode (result) {
    //   this.result = result

    //     event.getEventbyID_getorderdetail_bycode(this.$route.query.id,result)
    //     .then(res => {
    //         this.data = res.data; 
    //         this.id = res.data.id;
    //         this.form.att = res.data.order_details
    //         this.camera_hide = true;
    //         this.result_hide = false;
    //     }).catch ((err) => {
    //         var params = {title: 'Error', mode:'danger', data:err.response.data.message}
    //         EventBus.$emit('OPEN_MODAL_ALERT', params)
    //         this.camera_hide = true;
    //     })

    // },

    // async onInit (promise) {
    //   try {
    //     await promise
    //   } catch (error) {
    //     if (error.name === 'NotAllowedError') {
    //       this.error = "ERROR: you need to grant camera access permisson"
    //     } else if (error.name === 'NotFoundError') {
    //       this.error = "ERROR: no camera on this device"
    //     } else if (error.name === 'NotSupportedError') {
    //       this.error = "ERROR: secure context required (HTTPS, localhost)"
    //     } else if (error.name === 'NotReadableError') {
    //       this.error = "ERROR: is the camera already in use?"
    //     } else if (error.name === 'OverconstrainedError') {
    //       this.error = "ERROR: installed cameras are not suitable"
    //     } else if (error.name === 'StreamApiNotSupportedError') {
    //       this.error = "ERROR: Stream API is not supported in this browser"
    //     }
    //   }
    // },

    scan: function () {
      // this.camera_hide = false;
      // this.result_hide = true;
      
        event.getEventbyID_getorderdetail_bycode(this.$route.query.id,this.result)
        .then(res => {
            this.data = res.data; 
            this.id = res.data.id;
            this.form.att = res.data.order_details
            this.camera_hide = true;
            this.result_hide = false;
            error.innerHTML = "<span style='color: green;'>"+
            "Success - Recorded Successfully</span>"
        }).catch ((err) => {
            // var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            // EventBus.$emit('OPEN_MODAL_ALERT', params)
            // this.camera_hide = true;
            error.innerHTML = "<span style='color: red;'>"+
            "Error - Ticket ID Not Found. Please try again </span>"
            this.camera_hide = true;
        })  
        
        

    },

    check123(){
      if(this.result_hide === false){
        //alert('yes');
        this.submit();
      }
    },

    changeHandler: function () {
      if(this.result.length == '32'){
        this.scan();
      }
    },

    validatorTicket: function(val,max) {
      if(val >= 0 && val <= max){
        return null;
      }else{
        return false;
      }
      //return val ? (val >= 0 && val <= max) : false
    },
    messageInvalidFeedback: function(max) {
      return "Maksimal " + max + " tiket"
    },
    submit(){
      //alert('asd');
      this.loading_submit = true
      event.createEventAttendance(this.id, this.form)
      .then(res => {
          console.log(res.meesage)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          this.camera_hide = false;
          this.result_hide = true;
          this.loading_submit = false
          this.$refs.text.$el.focus();
      }).catch ((err) => {
          this.loading_submit = false
          console.log(err.response.data.message)
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
            this.$refs.text.$el.focus();
            
      })
    }

  }
}
</script>

<style scoped>
.error {
  font-weight: bold;
  color: red;
}
</style>